import { useMemo } from "react";
import LoyaltyRankRewardsList from "components/organisms/LoyaltyRankRewardsList";
import { useGetUserProgressLoyalty } from "queries/useGetUserProgressLoyalty";
import { useLoyaltyStore } from "stores/loyalty";
import { mapRewards } from "mappings/loyaltyRewards";

export const LoyaltyRankRewardsListContainer = () => {
  const { data } = useGetUserProgressLoyalty();
  const indexActiveRank = useLoyaltyStore((state) => state.indexActiveRank);
  const rank = data?.ranks[indexActiveRank];
  const nameRank = rank?.name || "";
  const rewardsRanks = useMemo(() => mapRewards(rank?.rewards), [rank]);
  const rewardsLevel = useMemo(
    () => rank?.levels.map(({ rewards }) => mapRewards(rewards)) || [],
    [rank],
  );

  return (
    <LoyaltyRankRewardsList
      nameRank={nameRank}
      rewardsRank={rewardsRanks}
      rewardsLevel={rewardsLevel}
    />
  );
};
